export default __webpack_public_path__ + "1b161197cbb7d1052ca8e74405969b8d.jpeg";